function BookingsModalController() {
    this.constructor.apply(this, arguments);
}

BookingsModalController.$inject = ['$mdDialog', '$state', 'vehicle', 'dayBooking', 'addable', 'scrollTop'];
BookingsModalController.prototype = {
    /**
     *
     * @param $mdDialog {$mdDialog}
     * @param $state {ui.IStateService}
     * @param vehicle {IVehicle}
     * @param dayBooking {IDayBooking}
     * @param addable { boolean}
     * @param scrollTop {number}
     */
    constructor($mdDialog, $state, vehicle, dayBooking, addable, scrollTop) {
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.vehicle = vehicle;
        this.dayBooking = dayBooking;
        this.addable = addable;
        this.scrollTop = scrollTop;

        this.bookings = dayBooking.Events;
        this.date = dayBooking.Date;
        this.strDate = moment(this.date, 'YYYY-MM-DD').format('dddd, DD/MM/YYYY');
    },

    /**
     * Close modal
     */
    closeDialog() {
        this.$mdDialog.cancel();
    },

    /**
     * Show modal to add new a booking
     */
    addNewBooking() {
        var vehicle = this.vehicle;
        var date = this.date;
        var startTime = "00:00";
        if (date === moment().format("YYYY-MM-DD")) {
            startTime = moment().format("HH:mm");
        }
        var event = {
            StartDate: date,
            StartTime: startTime,
            EndDate: date,
            EndTime: "23:59",
            isNew: true,
            Editable: true,
            Owner: true,
            VehicleId: vehicle.VehicleId,
            VehicleName: vehicle.VehicleName,
            VehicleModel: vehicle.VehicleModel
        };

        this.$mdDialog.hide(); // hide current model

        this.gotoAddEditBooking(event); // go to booking

    },

    /**
     * Go to add/edit booking page
     * @param vehicleBooking {IVehicleBooking}
     */
    gotoAddEditBooking(vehicleBooking) {
        this.$state.go('internal.editbooking', {
            id: vehicleBooking.Id,
            vehicleBooking: JSON.stringify(vehicleBooking),
            prevState: 'internal.addvehiclebooking',
            state: JSON.stringify({
                startDate: this.vehicle.Availabilities[0].Date,
                scrollTop: this.scrollTop
            })
        });
    },

    /**
     * Go to booking details page
     * @param vehicleBooking {IVehicleBooking}
     */
    gotoBookingDetails(vehicleBooking) {
        this.$state.go('internal.booking-details', {
            id: vehicleBooking.Id,
            prevState: 'internal.addvehiclebooking',
            state: JSON.stringify({
                startDate: this.vehicle.Availabilities[0].Date,
                scrollTop: this.scrollTop
            })
        });
    },

    /**
     * Go to booking page if you have permission
     * @param booking{IVehicleBooking}
     */
    gotoBooking(booking) {
        let canViewDetails = false;
        if(booking.IsMine) {
            canViewDetails = true;
        }
        if(canViewDetails) {
            this.$mdDialog.hide(booking);
            this.gotoBookingDetails(booking);
        }
    }
}

angular.module('internal.vehiclebookings').controller('BookingsModalController', BookingsModalController);